import React from "react";
import { ParticleField } from "./effects/ParticleField";
import { MaskedLines } from "./Reveal";
import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle }) => (
  <section data-testid="page-hero" className="relative overflow-hidden pt-40 pb-20 md:pt-52 md:pb-28 border-b border-white/5">
    <div className="absolute inset-0 opacity-70">
      <ParticleField density={50} />
    </div>
    <div className="absolute left-1/2 top-0 -translate-x-1/2 h-[26vw] w-[60vw] rounded-full bg-[#3B82F6]/12 blur-[130px] animate-breathe pointer-events-none" />
    <div className="relative mx-auto max-w-7xl px-6 md:px-12">
      <motion.span
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="font-mono text-xs tracking-[0.28em] uppercase text-[#60A5FA] flex items-center gap-3"
      >
        <span className="inline-block h-px w-8 bg-[#60A5FA]/50" />
        {overline}
      </motion.span>
      <MaskedLines
        className="mt-6 max-w-4xl"
        delay={0.15}
        lineClassName="text-5xl sm:text-6xl md:text-7xl font-medium tracking-tighter text-white leading-[1.02]"
        lines={[title]}
      />
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-7 max-w-2xl text-lg md:text-xl text-white/55 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
